export default "/images/95d7589cd3b075a839b5d066abed1c86.avif";